import React from 'react'
import PropTypes from 'prop-types'
import ConnectLayout from '/components/layouts/ConnectLayout'
import { Login as ConnectLogin } from '/components/auth/connect'

const Login = () => {
  return <ConnectLogin />
}

Login.Layout = ConnectLayout
Login.propTypes = {
  siteData: PropTypes.object
}

export default Login
